import React from "react";
import { Text, Flex, Box, type TextProps } from "@chakra-ui/react";
import NextImage from "next/image";
import { type Customer } from "lib/sanity";
import { Balancer } from "react-wrap-balancer";
import { Section, type SectionProps } from "components/section";
import { getCustomerLogoUrl, getCustomerLogoStyles } from "utils";
import { type Theme } from "contexts/color-theme";

type CustomerProps = {
  customers: Customer[];
  title?: string;
  titleMaxW?: TextProps["maxW"];
  theme?: Theme;
} & SectionProps;

export function Customers({
  customers,
  titleMaxW,
  title = "Trusted by teams at",
  theme = "light",
  ...props
}: CustomerProps) {
  return (
    <Section {...props}>
      <Flex
        direction="column"
        gap={{ base: "bigger", md: "biggest" }}
        w="100%"
        align="center"
        justify="start"
        overflow="hidden"
      >
        {title && (
          <Text textStyle={{ base: "headline3", md: "headline2" }} textAlign="center" maxW={titleMaxW} mx="auto">
            <Balancer>{title}</Balancer>
          </Text>
        )}

        <Flex flex={1} gap={10} flexWrap="wrap" align="center" justify="center">
          {customers.filter(Boolean).map((customer: Customer) => (
            <Box
              key={customer.slug}
              pos="relative"
              flex={{ base: "none", md: 1 }}
              w={{ base: "100px", lg: "100%" }}
              mx={2}
              maxW="100%"
              {...getCustomerLogoStyles(theme)}
            >
              <NextImage
                src={`${getCustomerLogoUrl(customer, theme)}?w=300`}
                alt={`${customer.name}.`}
                sizes="100%"
                width={5}
                height={2}
                style={{
                  objectFit: "contain",
                  width: "100%",
                  height: "unset",
                  maxWidth: "120px",
                  maxHeight: "40px",
                }}
              />
            </Box>
          ))}
        </Flex>
      </Flex>
    </Section>
  );
}
